import Checkbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    "&.Mui-checked": {
      color: "var(--primary-color)",
      "&:hover": {
        backgroundColor: "rgba(0,111,143,0.1)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(0,111,143,0.1)",
    },
  },
});
const Check = ({
  label,
  onClick,
  value,
  primary,
  labelStyle,
  checked,
  checkBoxStyle,
}) => {
  const classes = useStyles();
  return (
    <>
      <FormControlLabel
        label={label}
        classes={classes.label}
        className={primary ? "color-dark-grey-1" : "color-tertiary"}
        style={labelStyle}
        control={
          <Checkbox
            value={value}
            classes={classes}
            checked={checked}
            onClick={onClick}
            style={checkBoxStyle}
          />
        }
      />
    </>
  );
};

export default Check;
